import React, { FunctionComponent } from 'react';
import classNames from 'classnames';
import Image from 'react-retina-image';

import {
  Link,
  Heading,
  List,
  ListItem,
  Page,
  InstaFeed,
  Container,
} from '../..';

import styles from './IndexPage.module.scss';
import { LIST_TYPE_CRYSTAL, LIST_TYPE_TOOTH } from '../../../constants/list';
import { BRAND } from '../../../constants/brand';

interface IndexPageProps {
  className?: string;
  location?: object;
}

const IndexPage: FunctionComponent<IndexPageProps> = ({
  className,
  location,
}) => {
  const indexPageClass = classNames(
    `${BRAND.SUPER_SHORT_NAME}-index`,
    className,
    {
      [styles.indexPage]: true,
    },
  );
  return (
    <Page className={indexPageClass} location={location}>
      <div className={styles.hero}>
        <div className={styles.heroBox}>
          <Image
            forceOriginalDimensions={false}
            src="/images/logo.png"
            alt="Crystal Canine"
            className={styles.logo}
          />
          <Heading level={1} className={styles.heading}>
            London&apos;s Tooth Gem Company
          </Heading>
        </div>
      </div>
      <section className={styles.bannerList}>
        <Container>
          <Heading level={2} className={styles.why}>
            Why choose Crystal Canine?
          </Heading>
          <List>
            <ListItem type={LIST_TYPE_CRYSTAL}>
              Genuine swarovski tooth crystals
            </ListItem>
            <ListItem type={LIST_TYPE_CRYSTAL}>
              22k gold, white gold &amp; .1ct diamonds!
            </ListItem>
            <ListItem type={LIST_TYPE_CRYSTAL}>
              No drills, no pain, no problem!
            </ListItem>
            <ListItem type={LIST_TYPE_CRYSTAL}>
              Based in London Borough of Essex
              <br />
              (end of the Central Line)
            </ListItem>
          </List>
        </Container>
      </section>
      <section className={styles.pricing}>
        <Container>
          <Heading level={3}>Stand out from the crowd</Heading>
          <p className={styles.detail}>
            With over 150 options of crystals, gold &amp; diamonds, you can get
            something uniquely you!
          </p>
          <p className={styles.detail}>
            From loud and proud to subtle shine, as well as everything in
            between. We will get your smile looking real cute, real soon!
          </p>
          <p className={styles.detail}>
            Wanna feel inspired? Have a look at our virtual crystal menu to see
            just some of the possibilities.
          </p>
          <Link
            to="/prices"
            label="Clicking this link will take you through to our price list."
          >
            Crystal Menu
          </Link>
        </Container>
      </section>
    </Page>
  );
};

export default IndexPage;
